import { Plus, BarChart3, Gift } from "lucide-react";

const TABS = [
  { id: "active", label: (n) => `Activos (${n.active})`, color: "border-[#00FF66] text-[#00FF66]" },
  { id: "sold", label: (n) => `Vendidos (${n.sold})`, color: "border-[#B026FF] text-[#B026FF]" },
  { id: "reports", label: () => "Reportes", color: "border-amber-400 text-amber-400" },
  { id: "analytics", label: () => <span className="flex items-center gap-1.5"><BarChart3 className="w-3.5 h-3.5" /> Trafico</span>, color: "border-cyan-400 text-cyan-400" },
  { id: "referrals", label: () => <span className="flex items-center gap-1.5"><Gift className="w-3.5 h-3.5" /> Referidos</span>, color: "border-[#B026FF] text-[#B026FF]" },
];

export const AdminTabs = ({ activeTab, onChange, counts, onAdd }) => (
  <div className="flex items-center gap-4 mb-6 border-b border-white/5 overflow-x-auto scrollbar-hide">
    {TABS.map(tab => (
      <button
        key={tab.id}
        onClick={() => onChange(tab.id)}
        className={`pb-3 px-1 text-sm font-medium border-b-2 transition-colors whitespace-nowrap ${activeTab === tab.id ? tab.color : "border-transparent text-[#A0A0A0] hover:text-white"}`}
        data-testid={`tab-${tab.id}`}
      >
        {tab.label(counts)}
      </button>
    ))}
    {activeTab === "active" && (
      <button onClick={onAdd} className="ml-auto flex items-center gap-2 bg-[#00FF66] text-[#050505] px-4 py-2 font-bold text-sm rounded-full hover:shadow-[0_0_16px_rgba(0,255,102,0.4)] transition-all duration-300 whitespace-nowrap" data-testid="add-product-btn">
        <Plus className="w-4 h-4" /> Agregar
      </button>
    )}
  </div>
);
